import { HIDE_REPORT_MODAL, SHOW_REPORT_MODAL } from './finance.actionsTypes';
import  { ACTION_TYPES } from '../../config/constants';

export default function reportDetails(state = {}, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case SHOW_REPORT_MODAL:
            newState = null;
            newState = Object.assign(action, {});
            newState.show = true;
            return newState;
        case HIDE_REPORT_MODAL:
            return {
                show: false,
            };
        case ACTION_TYPES.LOGOUT_SUCCESS:
            return {};
        default:
            return newState;
    }
}